<!-- 商品表单 -->
<template>
    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="库存类型/生成人" width="120">
            <template slot-scope="scope">{{ scope.row.date }}</template>
        </el-table-column>
        <el-table-column prop="name" label="产品类型" width="120">
        </el-table-column>
        <el-table-column prop="address" label="资源方" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="address" label="车存ID" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="address" label="产品名称/产品ID" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="address" label="描述" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="address" label="库存价格" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="address" label="C端价格" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="address" label="B端价格" show-overflow-tooltip>
        </el-table-column>
    </el-table>
</template>

<script>

export default {
    components: {},
    data() {
        return {
            tableData: [{}]
        }
    },
    computed: {},
    watch: {},
    methods: {
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped></style>